import React, { useCallback, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'ncoded-component-library';
import { Field, Form } from 'react-final-form';
import InputFieldComponent from 'components/InputField';
import validations from 'validations';
import AuthContext from 'providers/Auth/Auth.context';
import classNames from 'classnames';
import AuthPageWrapper from 'components/AuthPageWrapper';
import { Link } from 'react-router-dom';

import './ForgotPassword.styles.scss';

type ForgotPasswordProps = Record<string, any>;

const ForgotPassword: React.FC<ForgotPasswordProps> = ({ className }) => {
  const { t } = useTranslation();
  const { forgotPasswordRequest } = useContext(AuthContext);
  const [emailSent, setEmailSent] = useState(false);

  const classes = classNames('forgot-password-page', className);

  const handleSubmit = useCallback(
    ({ email }: { email: string }) => {
      forgotPasswordRequest(email, () => setEmailSent(true));
    },
    [forgotPasswordRequest],
  );

  return (
    <AuthPageWrapper>
      <Form
        onSubmit={handleSubmit}
        render={({ handleSubmit, submitting, valid }) => (
          <form onSubmit={handleSubmit} className={classes}>
            {!emailSent ? (
              <>
                <Field
                  name="email"
                  component={InputFieldComponent}
                  label={t('email-label')}
                  placeholder={t('email-placeholder')}
                  validate={validations.emailValidation()}
                  required
                />
                <Link to="/login">{t('goToLogin')}</Link>
                <Button type="submit" disabled={submitting || !valid}>
                  {t('resetPassword')}
                </Button>
              </>
            ) : (
              <p>{t('forgot-password-title-sent')}</p>
            )}
          </form>
        )}
      />
    </AuthPageWrapper>
  );
};

export default ForgotPassword;
